export const mainMenuTourMeta = {
  releaseDate: '2026-04-01', // fecha de deploy — solo usuarios creados desde esta fecha ven este tour
  showTo: 'new'
}

export const mainMenuTour = [
  {
    name: "profile",
    element: "#profile-menu",
    title: "Bienvenido a Falkon 👋",
    intro: `Todo está listo para que comiences a crear tus envíos.<br/>
      Aquí tienes acceso a tu perfil, donde podrás configurar información clave para crear tus envíos más rápido y administrar los usuarios de tu cuenta.`,
    position: 'left'
  },
  {
    name: "rastreo",
    element: "#rastreo",
    title: "Seguimiento de tus envíos",
    intro: "Desde este menú puedes gestionar todos tus envíos. Aquí puedes consultar dónde está tu entrega, buscar tus guías y hacer seguimiento fácilmente.",
    position: 'right'
  },
  {
    name: "cotizar",
    element: "#cotizar",
    title: "Cotiza tu envío",
    intro: "Aquí puedes consultar el valor según el lugar de envío, el lugar de entrega y las características del paquete, de forma rápida y sencilla.",
    position: 'right'
  },
  {
    name: "generar-guia",
    element: "#generar-guia",
    title: "Crea tus envíos fácilmente",
    intro: `
      Genera tus guías y la recogida se programa automáticamente, sin costo adicional. </br></br> 
      <strong>¿Prefieres llevar tus paquetes a un punto TCC?</strong></br></br>
      Llévalos con tu guía lista y recibe <strong>5% de descuento adicional.<strong>
    `,
    position: 'right'
  },
  {
    name: "recaudo",
    element: "#recaudo",
    title: "Pago contra entrega",
    intro: `
      Asegura tus ventas. Nosotros cobramos por ti al entregar y tú monitoreas tu dinero en un solo lugar.
      </br>
      </br>
      Vende con confianza y recibe tus pagos directamente en tu cuenta.
    `,
    position: 'right'
  },
  {
    name: "rotulosdespacho",
    element: "#rotulosdespacho",
    title: "Prepara tu envío",
    intro: `
      ¿Olvidaste descargar o guardar la etiqueta de tu envío al crear la guía? 
      aquí la puedes buscar e imprimir para dejar tus paquetes listos.
    `,
    position: 'right'
  },
  {
    name: "novedades",
    element: "#novedades",
    title: "Novedades en tus entregas",
    intro: `
      Aquí puedes gestionar cualquier novedad que se presente durante la entrega y solucionarla fácilmente para evitar retrasos.
    `,
    position: 'right'
  },
  {
    name: "credito",
    element: "#credito",
    title: "Gestiona tu crédito",
    intro: `
      En esta opción puedes consultar tus facturas y mantenerte al día con tu crédito realizando tus pagos de forma electrónica.
    `,
    position: 'right'
  },
  {
    name: "indicadores",
    element: "#indicadores",
    title: "Vista general de tus envíos",
    intro: `
      Esta opción te permite ver información clave sobre tus envíos nuestro desempeño como tu aliado logístico y entender mejor tu operación para tomar decisiones
    `,
    position: 'right'
  },
  {
    name: "tiempos-entrega",
    element: "#menu-superior",
    title: "¿Necesitas ayuda?",
    intro: "Cuando lo necesites, este menú está para ayudarte. Puedes consultar los tiempos de entrega y encontrar información útil para tus envíos.",
    position: 'right'
  },
  {
    name: "whatsapp",
    element: "#b2chat-whatsapp-widget",
    title: "¡Todo listo para empezar!",
    intro: "Ya estás listo para empezar a enviar con Falkon. <br/>Y si en algún momento necesitas acompañamiento, estamos para ayudarte.",
    position: 'left'
  },
]